import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";


const DoubleChevronRight = (props) => {
  const { size, rotate } = props;

  const StyledIcon = styled.span`
    transform: scaleX(${rotate});
  `;


  return (
      <StyledIcon>
        <span>
          <svg
            height={size}
            width={size}
            fill="currentColor"
            viewBox="0 0 16 16"
          >
        
            <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"/>
            <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"/>
          </svg>
        </span>
      </StyledIcon>
  );
};

DoubleChevronRight.propTypes = {
  size: PropTypes.number,
  rotate: PropTypes.number,
};

DoubleChevronRight.defaultProps = {
  size: 16,
  rotate: 1,
};

export default React.memo(DoubleChevronRight);
